module.exports = __webpack_public_path__ + "img/google-qibla-finder-02.9a3485ba.jpg";